import { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import styles from "../styles";

/**
 * Renders a color scheme list component.
 *
 * @param {Object} props - The component props.
 * @param {Function} props.setColor - The function to set the color.
 * @param {Function} props.setFillColor - The function to set the fill color.
 * @param {Function} props.setTextColor - The function to set the text color.
 * @param {string} props.csrfToken - The CSRF token.
 * @param {Function} props.handleSaveColorScheme - The function to handle saving a color scheme.
 * @param {boolean} props.open - The flag indicating whether the color scheme list is open.
 * @returns {JSX.Element} The color scheme list component.
 */
const ColorSchemeList = ({ setColor, setFillColor, setTextColor, csrfToken, handleSaveColorScheme, open }) => {
    const [colorSchemes, setColorSchemes] = useState([]);
    const [xcrfToken, setXcsrfToken] = useState("");

    useEffect(() => {
        setXcsrfToken(csrfToken)

    }, [csrfToken]);

    useEffect(() => {
        if (xcrfToken !== "") {
            fetchColorSchemes();
        }
    }, [xcrfToken]);

    useEffect(() => {
        if (xcrfToken !== "") {
            fetchColorSchemes();
        }
    }, [open]);

    const fetchColorSchemes = async () => {
        try {
            const response = await fetch('/fretboard-api/color-schemes/?_format=json', {
                headers: {
                    'X-CSRF-Token': xcrfToken
                }
            });
            const data = await response.json();
            setColorSchemes(data);
        } catch (error) {
            console.error(error);
        }
    };

    const handleColorSchemeClick = (event) => {
        const selectedNid = event.target.value;
        switch (selectedNid) {
            case "":
                setColor("#cc1b33");
                setFillColor("#ffffff");
                setTextColor("#000000");
                break;
            case "save":
                // handle save new color scheme
                handleSaveColorScheme(event);
                break;
            default:
                const selectedColorScheme = colorSchemes.find((colorScheme) => colorScheme.nid[0].value === selectedNid);
                if (selectedColorScheme) {
                    const { field_note_border_color, field_note_fill_color, field_note_text_color } = selectedColorScheme;
                    setColor(field_note_border_color[0].value);
                    setFillColor(field_note_fill_color[0].value);
                    setTextColor(field_note_text_color[0].value);
                }
                break;
        }
    };

    return (
        <FormControl sx={styles.symbolStyle} id="color-scheme-form" size="small">
            <InputLabel id="colorscheme-select-symbol-label">Color Scheme</InputLabel>
            <Select
                labelId="colorscheme-select-symbol-label"
                id="colorscheme-select-symbol"
                autoWidth={true}
                label="Symbol"
                sx={styles.symbolStyle}
                onChange={handleColorSchemeClick}
            >
                {colorSchemes.map((colorScheme) => (
                    <MenuItem key={colorScheme.nid[0].value} value={colorScheme.nid[0].value}>
                        {colorScheme.title[0].value}
                    </MenuItem>
                ))}
                <MenuItem value={''}>Default</MenuItem>
                <MenuItem value={'save'}>Save New</MenuItem>
            </Select>
        </FormControl>
    );
};

export default ColorSchemeList;
